import React from 'react';
import { observer } from 'mobx-react';
import { InventoryListTemplate } from 'themes/application/inventory/pages';
import { setCurrentView } from 'core/utils';
import { InventoryViewStore } from 'application/inventory/stores';

@setCurrentView((rootStore) => new InventoryViewStore(rootStore), 'listViewStore')
@observer
class InventoryList extends React.Component {
    render() {
        return <InventoryListTemplate {...this.props} />
    }
}

export default InventoryList;